import axios from "axios";
import { getToken } from "../localstorage";

export type FetchDocumentsResponse<T = any> = {
  documents: T[];
};

export async function fetchDocumentsByUser<T = any>(powerpointId: string, token: string): Promise<FetchDocumentsResponse<T>> {
  const apiUrl = process.env.API_URL;
  const { data } = await axios.get(`${apiUrl}/documents-by-user`, {
    params: { powerpointId },
    headers: { Authorization: `Bearer ${token}` },
  });
  return data as FetchDocumentsResponse<T>;
}


export async function fetchDocumentById(documentId: string) {
  const apiUrl = process.env.API_URL as string;
  const token = await getToken();
  const resp = await axios.get(`${apiUrl}/document-by-id`, {
    headers: { Authorization: `Bearer ${token}` },
    params: { id: documentId },
  });
  return resp?.data || {};
}

export async function updateDocumentExcelInfo(documentId: string, oneDriveUrlExcelFileUrl: string, filename: string, documentData: any) {
  const apiUrl = process.env.API_URL as string;
  const token = await getToken();
  const resp = await axios.post(`${apiUrl}/document-edit`, {
    documentContent: documentData?.documentContent,
    llmGlobalState: documentData?.llmGlobalState,
    excelFileName: filename,
    excelFileLocation: oneDriveUrlExcelFileUrl,
  }, {
    headers: { Authorization: `Bearer ${token}` },
    params: { id: documentId },
  });
  return resp?.data || {};
}

export async function updateDocumentPlaceholder(documentId: string, documentData: any, updatedDocumentContent: any) {
  const apiUrl = process.env.API_URL as string;
  const token = await getToken();
    await axios.post(`${apiUrl}/document-edit`, {
    documentContent: JSON.stringify(updatedDocumentContent),
    llmGlobalState: documentData?.llmGlobalState,
    excelFileName: documentData?.excelFileName,
    excelFileLocation: documentData?.excelFileLocation,
  }, {
    headers: { Authorization: `Bearer ${token}` },
    params: { id: documentId },
  });
}